var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleSoct3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#afd0f0;}.cls-2,.cls-4{mix-blend-mode:screen;}.cls-3{opacity:0;}.cls-5{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 120.23,
    cy: 104.13,
    r: 68.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.96,121.5c0,14.13,11.46,25.59,25.59,25.59s25.59-11.46,25.59-25.59h-51.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.67,
    y: 87.75,
    width: 26.93,
    height: 20.05,
    rx: 10.02,
    ry: 10.02,
    transform: "translate(190.9 4.63) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 125.69,
    y: 87.75,
    width: 26.93,
    height: 20.05,
    rx: 10.02,
    ry: 10.02,
    transform: "translate(236.93 -41.39) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.68,
    y: 32.39,
    width: 78.37,
    height: 49.92,
    rx: 9.27,
    ry: 9.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.81,82.31v14.63c0,2.21-2.67,3.32-4.24,1.76l-16.33-16.33,20.57-.06Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleSoct3);
export default __webpack_public_path__ + "static/media/title-soct-3.751e38af5b2c4bf37051fdb0505a96f9.svg";
export { ForwardRef as ReactComponent };